<template>
  <el-dialog :title="'【' + modelParam.task_id + '】' + modelParam.describe" center class="devOps-modelFive"
    :visible.sync="dialogVisible" width="80%" top="10px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="主域名" prop="domain">
        <el-select style="width: 100%" disabled v-model="form.domain" @change="queryEnvInfo('runget')">
          <el-option v-for="(item, index) in domains" :key="index" :label="item[0] + ' （' + item[1] + '）'"
            :value="item[1]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块名" prop="module">
        <el-select disabled style="width: 100%" v-model="form.module" :placeholder="
          '默认为当前项目（' + modelParam.module_name + '）,暂时不可编辑'
        ">
          <el-option v-for="(item, index) in modules" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分支" prop="branch">
        <el-select style="width: 100%" v-model="form.branch" filterable remote reserve-keyword @change="onChangeBranch"
          :placeholder="
            modelParam.space === 'developerSpace'
              ? '默认为代码质量检测阶段的分支'
              : 'EIS模块默认为master-eis分支，其他默认为master分支'
          " :remote-method="remoteMethod.bind(this, 'branch')">
          <el-option v-for="item in branchOptions" :key="item.label" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="版本" prop="commit">
        <el-select style="width: 100%" v-model="form.commit" filterable remote @change="onChangeCommit" reserve-keyword
          placeholder="默认为当前分支的最新版本" :remote-method="remoteMethod.bind(this, 'commit')">
          <el-option v-for="item in commitOptions" :key="item.label" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="环境" prop="env">
        <el-select :disabled="modelParam.stage_name === 'operator_prodCodeDeploy'" style="width: 35%" v-model="form.env"
          placeholder="默认为额外部署阶段的环境" @change="queryEnvInfo('runget')">
          <el-option v-for="(item, index) in envs" :key="index" :label="item[0]" :value="item[1]"></el-option>
        </el-select>
        <el-popover @show="queryDeployCenterList()" placement="bottom" width="900" trigger="click">
          <el-table :cell-style="getRowClass" max-height="400" v-loading="loadingTable" :data="deploy_info">
            <el-table-column fixed width="150" property="moduleEnv" label="模块环境"></el-table-column>
            <el-table-column property="name" label="姓名" min-width="120"></el-table-column>
            <el-table-column property="branch" label="分支"></el-table-column>
            <el-table-column property="startDate" label="开始时间" min-width="100" sortable></el-table-column>
            <el-table-column property="holeUpTime" min-width="100" label="占用时间" sortable></el-table-column>
            <el-table-column property="commit" label="commit"></el-table-column>
            <el-table-column fixed="right" width="220" align="center" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" :type="releaseType(scope.row.holeUpTime)" plain
                  v-if="scope.row.platform === 'walle'" @click="handleRelease(scope.$index, scope.row)">发布({{
                  scope.row.platform
                  }})</el-button>
                <span v-else
                  style="color:#67c23a;color: rgb(103, 194, 58);width: 91.4px;display: inline-block;text-align: center;margin-right: 10px;">环境可用</span>
                <el-button size="mini" type="primary" plain @click="handleRorrelation(scope.$index, scope.row)">查看配置
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <span slot="reference" v-if="modelParam.stage_name !== 'operator_prodCodeDeploy'"
            style="margin-left: 20px; color: #67c23a; cursor: pointer">查看环境占用情况</span>
        </el-popover>
        <span style="margin-left: 20px; color: #e6a23c" v-if="intelligentEnv">智能选择的环境为 {{ intelligentEnv }}</span>
      </el-form-item>
      <el-form-item v-if="modelParam.space !== 'operatorSpace'" label="占用期限" prop="due_time">
        <el-date-picker style="width: 100%" v-model="form.due_time" type="datetime" default-time="23:59:59"
          placeholder="默认占用至当天结束">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="描述" prop="describe">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 16 }" placeholder="默认为当前版本的message"
          v-model="form.describe"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-top:5px;" :loading="runLoading" :disabled="nonStandard" type="warning" @click="onSubmit('run')">开始发布
        </el-button>
        <el-button style="margin-top:5px;" :loading="skipLoading" type="warning" @click="onSubmit('skip')">跳 过
        </el-button>
        <el-button style="margin-top:5px;" type="warning" @click="onSubmit('log')">实时日志</el-button>
        <el-button style="margin-top:5px;" type="info" @click="queryDevOpsSpaceListStageOutputApi">查看历史</el-button>
        <el-button style="margin-top:5px;" v-if="modelParam.stage_name === 'operator_prodCodeDeploy'" type="warning"
          @click="handleRollback">回 滚
        </el-button>
        <el-button style="margin:5px 0;" type="success" @click="handleClose">关 闭</el-button>
      </el-form-item>
    </el-form>
    <TableOne v-if="tableData.length" :tableData="tableData" />
    <el-dialog custom-class="rorrelationDialog" title="关联配置" :visible.sync="rorrelationDialogVisible" width="90%"
      :modal="false" append-to-body left>
      <pre style="
          white-space: pre-line;
          height: 300px;
          overflow-y: auto;
          background-color: #efefef;
        ">{{ rorrelationContent }}</pre>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
      title="生产环境代码发布" v-if="releaseResultVisible" :visible.sync="releaseResultVisible" append-to-body>
      <Progress :progressInfo="progressBar" />
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="preEnvTesting_model_dialog_child" width="80%" center
      title="生产环境实时日志" v-if="releaseResultLogVisible" :visible.sync="releaseResultLogVisible" append-to-body>
      <pre ref="webSocket" class="tips-message websocket_style" v-html="webSocket.msg" />
      <WebSocket v-if="webSocket.url" />
    </el-dialog>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  postODUDADcreateApi,
  getDevOpsSpaceListStageOutputApi,
  getDevOpsSpaceStageSelectmapApi,
  postDeployCenterApi,
  getAutoCustomerApi,
} from "@/server/tops/devOps";

import { Progress, WebSocket } from "@/components/index.js";
import { TableOne } from "../table/index";
import { filterSelectList, formatDate } from "../util";
import { mapState, mapMutations } from "vuex";
export default {
  components: { Progress, TableOne, WebSocket },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        domain: 'ehsy.com',
        env: 'production'
      },
      rules: {},
      branchs: [],
      branchOptions: [],
      envs: [],
      commits: [],
      commitOptions: [],
      modules: [],
      domains: [],
      message: "",
      runLoading: false,
      skipLoading: false,
      tableData: [],
      intelligentEnv: "",
      deploy_info: [],
      loadingTable: false,
      rorrelationContent: "",
      rorrelationDialogVisible: false,
      releaseResultVisible: false,
      releaseResultLogVisible: false,
    };
  },
  async mounted() {
    await this.queryDevOpsSpaceListStageParmInfo();
    await this.queryDevOpsSpaceStageSelectmapApi();
  },
  computed: {
    ...mapState({
      progressBar: (state) => state.devOps.PROGRESSSBAR,
      webSocket: (state) => state.devOps.WEBSOCKET
    }),
    nonStandard() { // 非标系统标识
      return this.modelParam.module_name.startsWith('非标-')
    }
  },
  updated() {
    this.scrollToBottom({ bind: this, refName: 'webSocket' })
  },
  methods: {
    ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
    getRowClass({ row, column, rowIndex, columnIndex }) {
      console.log(row, column, rowIndex, columnIndex)
      if (columnIndex === 4) {
        return "color:#F56C6C";
      }
    },
    releaseType(time) {
      if (!time) return "success";
      let t = this.$moment().diff(time, "hour");
      if (t <= -24) {
        return "danger";
      } else if (t >= 0) {
        return "success";
      } else {
        return "warning";
      }
    },
    handleRelease(index, row) {
      window.open(row.release_url);
    },
    async handleRorrelation(index, row) {
      try {
        const ret = await getAutoCustomerApi(row.rorrelation_url);
        this.rorrelationContent = ret || "";
        if (ret) {
          this.rorrelationDialogVisible = true;
        }
      } catch (error) {
        this.rorrelationContent = "";
        this.rorrelationDialogVisible = false;
      }
    },
    async queryDeployCenterList() {
      try {
        this.loadingTable = true;
        const { module_name = "" } = this.modelParam;
        let services = [];
        module_name && services.push(module_name);
        const ret = await postDeployCenterApi({
          action: "add",
          services: services,
        });
        let deploy_info = [];
        ret[module_name]?.deploy_info?.forEach((item) => {
          item?.records.forEach((itm) => {
            deploy_info.push({
              moduleEnv: itm[2],
              name: itm[0],
              branch: itm[4],
              rorrelation_url:
                item.config_url_prefix + itm[2] + item.config_url_postfix,
              release_url: itm[1],
              holeUpTime: itm[6],
              commit: itm[3],
              startDate: itm[5],
              platform: item.platform,
            });
          });
        });
        deploy_info.sort(function (a, b) {
          return new Date(a.holeUpTime) - new Date(b.holeUpTime)
        })
        this.deploy_info = deploy_info;
      } catch (error) {
      } finally {
        this.loadingTable = false;
      }
    },
    // 获取select
    async queryDevOpsSpaceStageSelectmapApi() {
      const { module_name = "", stage_name = "" } = this.modelParam || {};
      try {
        const ret = await postODUDADcreateApi({
          module_name: module_name || "BACKEND",
          domain:this.form.domain
        });
        this.branchs = this.branchOptions = ret.branchs.map((item) => {
          return { value: `${item}`, label: `${item}` };
        });

        this.commits = this.commitOptions = ret.commits.map((item) => {
          return { value: `${item.split(" ")[0]}`, label: `${item}` };
        });
        const res = await getDevOpsSpaceStageSelectmapApi();
        this.domains = res[stage_name + "-domain"];
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      }
    },
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id, stage_name } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let env = stage_name === 'operator_prodCodeDeploy' ? 'production' : (ret.data.env || 'intelligent');
          this.form = { ...this.form, ...ret.data, commit: "", env };
          if (ret.data.branch) {
            this.onChangeBranch();
          }
          if (this.form.env === "intelligent") {
            await this.queryEnvInfo("runget");
          }
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      const { stage_id = "", task_id = "" } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableData = instance;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 回滚事件
    handleRollback() {
      const { domain = 'ehsy.com' } = this.form;
      const url = `http://jenkins.ehsy.com/job/${this.modelParam.module_name}.${domain}/`
      console.log(url)
      window.open(url)
    },
    // 提交
    async onSubmit(action) {
      action === "run" && (await this.queryActionRunSubmit(action));
      action === "skip" && (await this.queryActionSkipSubmit(action));
      action === "log" && (await this.queryActionNowLogSubmit(action));
    },
    // 实时日志
    async queryActionNowLogSubmit() {
      const {
        stage_id = "",
        task_id = "",
        pid = ''
      } = this.modelParam;
      this.tableData = [];
      this.releaseResultLogVisible = true;
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      this.openWebSocket({
        url: '/ws/devops',
        params: { pid, task_id, stage_id, username },
        title: '生产环境代码发布'
      })
    },
    // 获取智能选择环境
    async queryEnvInfo(action) {
      const {
        module = "",
        describe = "",
        due_time = "",
        branch = "",
        commit = "",
        env = "",
        domain = "",
      } = this.form;
      if (env !== "intelligent") {
        this.intelligentEnv = "";
        return;
      }
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
        domain,
        module,
        describe,
        due_time: due_time
          ? this.$moment(due_time).format("YYYY-MM-DD HH:mm:ss")
          : "",
        branch,
        commit,
        env,
      };
      try {
        this.intelligentEnv = "";
        const ret = await postDevopsSpaceStageActionApi(param);
        this.intelligentEnv = ret || "";
      } catch (error) {
        this.intelligentEnv = "";
      }
    },
    // 延迟设置进度条
    timeOutSetProgressBar(completeInfo, status = 'exception') {
      const initProgressBar = {
        percentage: 100,
        title: this.form.module || '',
        customColor: "",
      }
      setTimeout(() => {
        this.setProgressBar({
          ...initProgressBar,
          completeInfo,
          status,
        });
      }, 500)
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
            pid = ''
          } = this.modelParam;
          const {
            module = "",
            describe = "",
            due_time = "",
            branch = "",
            commit = "",
            env = "",
            domain = "",
          } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            domain,
            module,
            describe,
            due_time: due_time
              ? this.$moment(due_time).format("YYYY-MM-DD HH:mm:ss")
              : "",
            branch,
            commit,
            env,
          };
          try {
            const cacheDate = new Date();
            this.runLoading = true;
            this.releaseResultVisible = true;
            this.tableData = [];
            const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
            this.openWebSocket({
              url: '/ws/devops',
              params: { pid, task_id, stage_id, username },
              title: '生产环境代码发布'
            })
            const ret = await postDevopsSpaceStageActionApi(param);
            const output = ret?.data?.output || {};
            if (typeof output === 'string') {
              this.$notify({
                message: output || "数据错误",
                type: "error",
              });
            }
            const isSuccess = typeof output === 'string' ? false : output?.deploy[0]?.code === 0;
            this.timeOutSetProgressBar(`发布${isSuccess ? "成功" : "失败"}，用时：${formatDate(this, this.$moment(new Date()).diff(cacheDate))}`, `${isSuccess ? "success" : "exception"}`)
          } catch (error) {
            this.timeOutSetProgressBar('发布失败')
          } finally {
            this.runLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 跳过接口调用
    async queryActionSkipSubmit(action) {
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
        tester: "",
      };
      try {
        this.skipLoading = true;
        const ret = await postDevopsSpaceStageActionApi(param);
        const { output = {} } = ret.data || {}
        const message = (() => {
          if (typeof output === 'string') {
            return output
          }
          if (ret.status === 'failed') {
            if (Reflect.has(output, 'sql')) {
              return output.sql[0]?.msg
            }
            if (Reflect.has(output, 'deploy')) {
              return output.deploy[0]?.msg
            }
            return "跳过失败"
          } else {
            return "跳过成功"
          }
        })()
        this.$notify({
          message,
          type: ret.status === "success" ? "success" : "error",
        });
        ret.status === "success"
          ? this.hideDialogVisible("dialogVisible" + this.modelParam.stage)
          : (this.message = JSON.stringify(ret.data || "", null, 2));
      } catch (error) {
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.skipLoading = false;
      }
    },
    remoteMethod(key = "", query = "") {
      this[key + "Options"] = filterSelectList(this[key + "s"], query);
    },
    onChangeCommit(val) {
      this.form.commit = val;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // 版本change事件
    async onChangeBranch() {
      this.form.commit = "";
      this.commits = [];
      this.commitOptions = [];
      const { module_name = "" } = this.modelParam || {};
      try {
        const ret = await postODUDADcreateApi({
          module_name: module_name || "",
          branch: this.form.branch,
        });
        this.commits = this.commitOptions =
          ret?.commits?.map((item) => {
            return { value: `${item.split(" ")[0]}`, label: `${item}` };
          }) || [];
        this.form.commit = ret?.commits ? ret.commits[0].split(" ")[0] : "";
      } catch (error) { }
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}
</style>
<style lang="scss">
.rorrelationDialog {
  .el-dialog__body {
    padding: 1px 20px;
  }
}

.devOps-modelFive {

  .el-textarea__inner,
  .el-input__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }

  .el-form-item {
    margin-bottom: 12px;
  }
}
</style>